<template>
  <el-dialog title="Adicionar Imóveis" @open="iniciar"  :visible.sync="visibility" :before-close="fechar" :close-on-click-modal="false" :modal-append-to-body="false" width="50%">
    <el-form size="small" label-position="top">
      <div style="5px 10px; margin: 5px -10px 10px -10px;">                
        <el-row :gutter="10">
          <el-col :span="18">
            <el-form-item label="ID/Endereço">
              <el-input auto-complete="off" v-model="filtroImovel"/>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label=" ">
              <el-radio-group v-model="filtroLista" @change="atualizarLista">
                <el-radio label="TODOS">Todos os Imóveis</el-radio>
                <el-radio label="SEMELHANTES">Imóveis Semelhantes</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <el-table :data="imoveisFiltrados" stripe height="400" size="small" highlight-current-row @selection-change="marcarImovelVisita">
      <el-table-column type="selection" width="30"/>
      <el-table-column label="ID" prop="idNaImobiliaria" width="60"/>
      <el-table-column label="Endereco">
        <template slot-scope="scope">
          <el-row :gutter="10" style="padding: 2px 0px" :style="{ backgroundColor: '#87CF87' }">
            <el-col :span="6" style="font-weight: bold">
              <span> {{ scope.row.status }} </span>
            </el-col>
            <el-col :span="10" style="font-weight: bold;">
              <span> {{ scope.row.tipoImovel.nome }} </span>
            </el-col>
            <el-col :span="8" style="text-align: right; font-weight: bold; padding-right: 12px">
              <span >{{ util.formatarValor(scope.row.valor) }}</span>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="24" :md="24" style="margin: 2px 0px -5px 0px;">
              {{ util.formatarLinha1EnderecoImovel(scope.row) }}
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="24" :md="24" style="margin: 0px 0px 2px 0px;">
              {{ util.formatarLinha2EnderecoImovel(scope.row) }}
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button @click="gravarImoveisHandler" type="primary" size="small" round class="btn-box-shadow">Adicionar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex';

import Util from "../../../util/funcoes.js";

export default {
  props: {
    visibility: Boolean,
    atendimento: Object,
    operacao: String
  },
  data() {
    return {
      imoveis: [],
      imoveisSelecionados: [],
      filtroImovel: "",
      filtroLista: 'TODOS'
    }
  },
  computed: {
    util() { return Util },
    imoveisFiltrados() { return (this.filtroImovel ? this.imoveis.filter(this.filtrarImoveis) : this.imoveis) }
  },
  methods: {
    ...mapActions([
      "showLoading",
      "hideLoading"
    ]),
    ...mapActions("vendasImoveisStore", ["listarImoveis"]),
    ...mapActions("vendasAtendimentosStore",["gravarImoveisAtendimento","listarImoveisSemelhantes"]),

    atualizarLista() { this.filtroLista === 'TODOS' ? this.iniciar() : this.listarSemelhantes() },

    iniciar() {
      this.filtroLista = 'TODOS'

      let payload = {
        operacao: this.operacao,
        status: 'DISPONIVEL',
        pagina: -1,
        isImoveisSemelhantes: true
      };

      this.showLoading();
      this.listarImoveis(payload)
      .then((resultado) => {
        this.hideLoading();
        this.imoveis = resultado.lista;
      })
      .catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    listarSemelhantes() {
      this.showLoading();
      this.listarImoveisSemelhantes(this.atendimento)
      .then((resultado) => {
        this.hideLoading();
        this.imoveis = resultado.lista;
      })
      .catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    gravarImoveisHandler() {
      let payload = {
        id: this.atendimento.id,
        imoveisSemelhantes: this.imoveisSelecionados
      }

      this.showLoading();
      this.gravarImoveisAtendimento(payload)
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
        this.fechar();
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    fechar() {
      this.$emit("close");
      this.imoveis = [];
      this.imoveisSelecionados = [];
    },

    //HELPER FUNCTIONS
    marcarImovelVisita(val) {
      this.imoveisSelecionados = val;
    },
    filtrarImoveis(imovel) {
      return (
        imovel.idNaImobiliaria.startsWith(this.filtroImovel) 
        || imovel.endereco.includes(this.filtroImovel) 
        || (imovel.numeroEndereco ? imovel.numeroEndereco.includes(this.filtroImovel) : false)
        || (imovel.condominio.nome ? imovel.condominio.nome.includes(this.filtroImovel) : false)
        || (imovel.bairro.nome ? imovel.bairro.nome.includes(this.filtroImovel) : false)
        || (imovel.cidade.nome ? imovel.cidade.nome.includes(this.filtroImovel) : false))
    }
  }
}
</script>

